import { render, staticRenderFns } from "./customer_profile.vue?vue&type=template&id=7a8ceeca&"
import script from "./customer_profile.vue?vue&type=script&lang=js&"
export * from "./customer_profile.vue?vue&type=script&lang=js&"
import style0 from "./customer_profile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports